/* PDP2 Phase 1 — purchase state (Chair Dinkum)
 * Runs after Impulse's own variantChange handlers and sets the true state of the selected variant:
 *   stock > 0 (or untracked & available) -> ADD TO CART
 *   stock <= 0, CONTINUE, on an incoming shipment with capacity (CAP-PO1) -> PRE-ORDER + arrival line + Dispatch property
 *   stock <= 0 and policy CONTINUE        -> PRE ORDER (+ pre-order line)
 *   stock <= 0 and policy DENY / unavailable -> SOLD OUT (button disabled)
 * Also hides 'fulfilment' reassurance rows and accelerated checkout unless the variant is in stock.
 * Does not touch variant selection, URLs, prices or the Herman Miller warranty selector.
 */
(function () {
  'use strict';

  function cfgFor(section) {
    var el = section.querySelector('script[data-cd-ps]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function stateOf(cfg, v) {
    if (!v) return 'out';
    if (!v.inventory_management) return v.available === false ? 'out' : 'in';
    var o = null;
    if (cfg.inv && cfg.inv[String(v.id)]) o = { quantity: cfg.inv[String(v.id)][0], policy: cfg.inv[String(v.id)][1] };
    var inv = window.inventories && window.inventories[String(cfg.productId)];
    if (!o) o = inv && inv[v.id];
    if (!o) {
      var node = document.querySelector('.js-product-inventory-data[data-product-id="' + cfg.productId + '"] .js-variant-inventory-data[data-id="' + v.id + '"]');
      if (node) o = { quantity: node.getAttribute('data-quantity'), policy: node.getAttribute('data-policy') };
    }
    var q = o ? parseInt(o.quantity, 10) : (v.available ? 1 : 0);
    var policy = o ? o.policy : '';
    if (q > 0) return 'in';
    // CAP-PO1: no stock now, but on an incoming shipment with pre-order capacity left
    if (policy === 'continue' && cfg.inc && cfg.inc[String(v.id)] > 0) return 'inc';
    if (policy === 'continue' && v.available !== false) return 'pre';
    return 'out';
  }

  function apply(section, variant) {
    var cfg = cfgFor(section);
    if (!cfg || !variant) return;
    var st = stateOf(cfg, variant);
    section.__cdState = st;
    section.__cdCfg = cfg;

    var btn = section.querySelector('[data-add-to-cart]');
    var txt = section.querySelector('[data-add-to-cart-text]');
    if (btn && txt) {
      if (st === 'out') {
        btn.disabled = true;
        btn.classList.add('disabled');
        txt.textContent = cfg.soldOut;
      } else {
        btn.disabled = false;
        btn.classList.remove('disabled');
        txt.textContent = st === 'inc' ? (cfg.incBtn || cfg.preorder) : (st === 'pre' ? cfg.preorder : cfg.addToCart);
      }
    }

    var inv = section.querySelector('[data-product-inventory]');
    if (inv && st !== 'in') {
      var li = inv.closest('.sales-point');
      inv.textContent = st === 'inc' ? cfg.incText : (st === 'pre' ? cfg.preText : cfg.outText);
      if (li) { li.classList.remove('hide'); li.hidden = false; }
      if (inv.parentNode) inv.parentNode.classList.toggle('inventory--low', st === 'out');
    }

    section.querySelectorAll('[data-cd-row="fulfilment"]').forEach(function (row) {
      row.hidden = st !== 'in';
    });

    var pay = section.querySelector('.shopify-payment-button');
    if (pay) pay.style.display = st === 'in' ? '' : 'none';
    setIncProp(section, cfg, st === 'inc');
  }

  // CAP-PO1: a visible line-item property so the cart, checkout, confirmation email and the order all say
  // the chair ships with the incoming shipment. Disabled (so not submitted) for any other state.
  function setIncProp(section, cfg, on) {
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var el = form.querySelector('input[data-cd-inc-prop]');
    if (on && cfg.incProp) {
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[Dispatch]';
        el.setAttribute('data-cd-inc-prop', '');
        form.appendChild(el);
      }
      el.value = cfg.incProp;
      el.disabled = false;
    } else if (el) {
      el.disabled = true;
    }
  }

  function currentVariant(section) {
    var sel = section.querySelector('select[name="id"]');
    var json = section.querySelector('textarea[data-variant-json]');
    if (!sel || !json) return null;
    try {
      var vs = JSON.parse(json.value);
      for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(sel.value)) return vs[i];
    } catch (e) {}
    return null;
  }

  // Other scripts (theme / app init) can re-enable the button after us; keep SOLD OUT disabled.
  function guard(section) {
    var btn = section.querySelector('[data-add-to-cart]');
    if (!btn || btn.__cdObs || !window.MutationObserver) return;
    btn.__cdObs = new MutationObserver(function () {
      if (section.__cdState === 'out' && !btn.disabled) {
        btn.disabled = true;
        btn.classList.add('disabled');
        var tx = section.querySelector('[data-add-to-cart-text]');
        if (tx && section.__cdCfg) tx.textContent = section.__cdCfg.soldOut;
      }
    });
    btn.__cdObs.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  function init() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      if (section.__cdPs) return;
      section.__cdPs = true;
      section.addEventListener('variantChange', function (evt) {
        var v = evt.detail && evt.detail.variant;
        setTimeout(function () { apply(section, v); }, 0);
      });
      apply(section, currentVariant(section));
      guard(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
